import EXIF from 'exif-js';
import { getUnixTime, parse } from 'date-fns';

const getEXIF = file => (
  new Promise((resolve) => {
    EXIF.getData(file, () => {
      resolve(file.exifdata);
    });
  })
);

export async function getFileTimestamp(file) {
  const exif = await getEXIF(file);
  if (exif.DateTime) {
    return getUnixTime(parse(exif.DateTime, 'yyyy:MM:dd HH:mm:ss', new Date()));
  }
  return getUnixTime(new Date(file.lastModified));
}

export const getBase64 = (file, opt) => {
  const options = opt || { asUrl: false };
  const { asUrl } = options;
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = asUrl ?
        reader.result : reader.result.substring(reader.result.indexOf(',') + 1);
      resolve(base64);
    };
    reader.readAsDataURL(file);
  });
};
